/**
 * Ferox Men sticky buy bar - Horizon 3.4 + Kaching Bundles integráció
 *
 * Működés:
 * - A bundle adatokat (1-2-3 hónap, ár, akciós ár, badge) a Kaching által az oldalba
 *   szerver oldalon beágyazott JSON-ból olvassa, így mindig szinkronban van az appal.
 * - A csomagválasztás a Kaching sáv rejtett rádiógombját kattintja meg (a Kaching a
 *   change eseményre vált csomagot, a rádió programozott klikkje ezt szinkron kiváltja).
 * - A Kosárba gomb a téma valódi Add to cart gombját nyomja meg (puppet minta, ugyanaz,
 *   amit a Horizon beépített sticky bárja használ). A Kaching a kosár-kérést elfogja és
 *   a kiválasztott csomag darabszámát, kedvezményét és ajándékát érvényesíti, pontosan
 *   úgy, mintha a vásárló kézzel kattintana.
 * - Ha a Kaching nem elérhető vagy nem igazolható a kiválasztás, a kiválasztott darabszám
 *   közvetlenül kerül a kosárba (?kaching_bundles=true bypass, így az app elfogója
 *   garantáltan nem módosítja).
 * - Bármilyen váratlan hiba esetén a sáv egyszerűen rejtve marad, az oldal többi része
 *   érintetlenül működik tovább.
 */
(function () {
  'use strict';

  if (window.__fxStickyBarInit) return;
  window.__fxStickyBarInit = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    try {
      init();
    } catch (e) {
      /* Ha bármi váratlan hiba lenne, a sáv nem jelenik meg, az oldal érintetlen. */
      if (window.console && console.warn) console.warn('[FeroxStickyBar] init hiba:', e);
    }
  });

  function init() {
    var root = document.getElementById('fx-sticky-bar');
    if (!root) return;

    var productId = root.dataset.productId;
    var pillsWrap = root.querySelector('[data-fx-pills]');
    var cta = root.querySelector('[data-fx-cta]');
    if (!pillsWrap || !cta) return;

    // A bolt ingyenes szállítási küszöbe: e felett jár az ingyenes kiszállítás
    var FREE_SHIPPING_MIN = 20000;

    var huFormat = new Intl.NumberFormat('hu-HU');
    function money(n) {
      return huFormat.format(Math.round(n)) + ' Ft';
    }

    /* ---------- Bundle adatok kiolvasása a Kaching JSON-ból ---------- */

    var deals = null;
    var selectedIndex = 0;

    try {
      var settingsEl = document.querySelector(
        'script.kaching-bundles-deal-block-settings[data-product-id="' + productId + '"]'
      );
      var productEl = document.querySelector(
        'script.kaching-bundles-product[data-product-id="' + productId + '"][data-main="true"]'
      );

      if (settingsEl && productEl) {
        var settings = JSON.parse(settingsEl.textContent);
        var kachingProduct = JSON.parse(productEl.textContent);
        var variant = kachingProduct.variants && kachingProduct.variants[0];

        if (variant && settings.dealBars && settings.dealBars.length) {
          var unitPrice = variant.price / 100;
          var unitCompare = (variant.compareAtPrice || variant.price) / 100;

          var unknownType = '';
          deals = settings.dealBars.map(function (bar) {
            var qty = bar.quantity || 1;
            var value = Number(bar.discountValue) || 0;
            var type = bar.discountType || 'default';
            var total;
            if (type === 'specific') {
              // fix csomagár: a Kaching a csomag teljes árát adja (pl. 2 doboz 19 200 Ft)
              total = value;
            } else if (type === 'amount') {
              total = (unitPrice - value) * qty;      // darabonkénti kedvezmény
            } else if (type === 'percentage' || type === 'percent') {
              total = unitPrice * (1 - value / 100) * qty;
            } else if (type === 'default' || type === 'none') {
              total = unitPrice * qty;
            } else {
              unknownType = type;
              total = NaN;
            }
            total = Math.round(total);
            var badge = bar.badgeText || '';
            // Az ingyenes szállítás erősebb érv a badge-ben, mint az app szövege
            if (total >= FREE_SHIPPING_MIN) badge = 'Ingyenes szállítás';
            return {
              title: qty + ' hónap',
              badge: badge,
              quantity: qty,
              total: total,
              compare: Math.round(unitCompare * qty)
            };
          });

          // Ismeretlen kedvezménytípusnál (a Kaching adminban átállított csomagnál) a sáv inkább
          // nem jelenik meg, mint hogy más árat mutasson, mint a Kaching blokk és a kosár.
          var badPrice = deals.some(function (d) { return !(d.total > 0); });
          if (unknownType || badPrice) {
            if (window.console && console.warn) {
              console.warn('[FeroxStickyBar] ismeretlen Kaching kedvezménytípus vagy érvénytelen ár:', unknownType || 'ár <= 0');
            }
            deals = null;
          } else {
            var preIdx = settings.dealBars.findIndex(function (bar) {
              return bar.id === settings.preselectedDealBarId;
            });
            if (preIdx >= 0) selectedIndex = preIdx;
          }
        }
      }
    } catch (e) {
      deals = null;
    }

    // Bundle adatok nélkül a sáv egyáltalán nem jelenik meg: így nem fordulhat elő,
    // hogy a gomb mást tenne a kosárba, mint amit a sáv mutat.
    if (!deals) {
      if (window.console && console.warn) {
        console.warn('[FeroxStickyBar] Kaching bundle adat nem található, a sáv rejtve marad.');
      }
      return;
    }

    /* ---------- Pillek felépítése ---------- */

    var pillButtons = [];

    deals.forEach(function (deal, i) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'fx-pill';
      pill.setAttribute('aria-pressed', 'false');

      if (deal.badge) {
        var badge = document.createElement('span');
        badge.className = 'fx-pill__badge';
        badge.textContent = deal.badge;
        pill.appendChild(badge);
      }

      var title = document.createElement('span');
      title.className = 'fx-pill__title';
      title.textContent = deal.title;
      pill.appendChild(title);

      var prices = document.createElement('span');
      prices.className = 'fx-pill__prices';

      var price = document.createElement('span');
      price.className = 'fx-pill__price';
      price.textContent = money(deal.total);
      prices.appendChild(price);

      if (deal.compare > deal.total) {
        var compare = document.createElement('s');
        compare.className = 'fx-pill__compare';
        compare.textContent = money(deal.compare);
        prices.appendChild(compare);
      }

      pill.appendChild(prices);

      pill.addEventListener('click', function () {
        selectPill(i, true);
      });

      pillsWrap.appendChild(pill);
      pillButtons.push(pill);
    });

    var ctaLabel = cta.querySelector('.fx-sticky-bar__cta-label');
    var perksEl = root.querySelector('[data-fx-perks]');

    // A CTA felirata mindig a kiválasztott csomagot erősíti meg, a szállítási
    // előnysor pedig csak a 2-3 hónapos csomagoknál látszik. Csak kijelzés:
    // a kosárba tételi logikát nem érinti.
    function updateCta() {
      var deal = deals[selectedIndex];
      if (ctaLabel && deal) {
        var nevelo = deal.quantity === 1 ? 'az' : 'a';
        ctaLabel.textContent = 'Kérem ' + nevelo + ' ' + deal.quantity + ' hónapos csomagot';
      }
      if (perksEl && deal) {
        if (deal.quantity < 2) {
          perksEl.hidden = true;
        } else {
          var shipping =
            deal.total >= FREE_SHIPPING_MIN
              ? 'Ingyenes 1-2 napos szállítás'
              : '1-2 napos gyors szállítás';
          perksEl.textContent = '';
          var item = document.createElement('span');
          item.className = 'fx-perk';
          item.textContent = shipping + ' + csomagpont elérhető';
          perksEl.appendChild(item);
          perksEl.hidden = false;
        }
      }
    }

    function paintSelection() {
      pillButtons.forEach(function (pill, i) {
        pill.setAttribute('aria-pressed', i === selectedIndex ? 'true' : 'false');
      });
      updateCta();
    }

    /* ---------- Szinkron a Kaching bundle sávokkal ---------- */

    var pendingKachingIndex = null;

    // A sávokat mindig a termék-űrlaphoz legközelebbi Kaching blokkra szűkítjük,
    // hogy egy esetleges duplikált (rejtett) blokk ne zavarja az index-párosítást.
    function getKachingBars() {
      var containers = document.querySelectorAll('.kaching-bundles');
      for (var c = 0; c < containers.length; c++) {
        var bars = Array.prototype.slice
          .call(containers[c].querySelectorAll('.kaching-bundles__bar'))
          .filter(function (bar) {
            return bar.offsetParent !== null;
          });
        if (bars.length) return bars;
      }
      // Végső tartalék: dokumentum szintű keresés
      return Array.prototype.slice
        .call(document.querySelectorAll('.kaching-bundles__bar'))
        .filter(function (bar) {
          return bar.offsetParent !== null;
        });
    }

    function getKachingRadio(index) {
      var bars = getKachingBars();
      return bars[index] ? bars[index].querySelector('input[type="radio"]') : null;
    }

    function isKachingSelected(index) {
      var radio = getKachingRadio(index);
      if (radio) return radio.checked;
      var bars = getKachingBars();
      return !!(bars[index] && bars[index].classList.contains('kaching-bundles__bar--selected'));
    }

    // A Kaching a rejtett rádió change eseményére vált csomagot; a rádió programozott
    // klikkje szinkron beállítja a checked állapotot és kiváltja a change eseményt.
    function selectKachingBar(index) {
      var radio = getKachingRadio(index);
      if (radio && !radio.disabled) {
        if (!radio.checked) radio.click();
        pendingKachingIndex = null;
        return radio.checked;
      }
      var bars = getKachingBars();
      if (!bars.length || !bars[index]) {
        pendingKachingIndex = index;
        return false;
      }
      // Nincs rádió (app-verzió változás): a sávra kattintunk és utólag ellenőrzünk
      bars[index].click();
      pendingKachingIndex = null;
      return isKachingSelected(index);
    }

    function selectPill(index, syncKaching) {
      selectedIndex = index;
      paintSelection();
      if (syncKaching) selectKachingBar(index);
    }

    // Ha az oldalon (a Kaching blokkban) váltanak csomagot, a sticky bar kövesse.
    // Stabil szülő elemet figyelünk subtree móddal, így a Kaching általi
    // újrarenderelés (elemcsere) sem szakítja meg a szinkront.
    var syncObserver = null;

    function watchKachingSelection() {
      if (syncObserver) return;
      var bars = getKachingBars();
      if (!bars.length) return;

      var container = bars[0].closest('.kaching-bundles') || bars[0].parentElement;
      if (!container) return;

      syncObserver = new MutationObserver(function () {
        var current = getKachingBars();
        for (var i = 0; i < current.length; i++) {
          if (current[i].classList.contains('kaching-bundles__bar--selected')) {
            if (i !== selectedIndex && pillButtons[i]) {
              selectedIndex = i;
              paintSelection();
            }
            break;
          }
        }
      });

      syncObserver.observe(container, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class']
      });

      // Induláskor átvesszük az oldalon éppen kiválasztott csomagot
      for (var i = 0; i < bars.length; i++) {
        if (bars[i].classList.contains('kaching-bundles__bar--selected')) {
          selectedIndex = i;
          paintSelection();
          break;
        }
      }
    }

    // A Kaching kliens oldalon, akár késve renderel (consent manager, lassú net).
    // DOM-figyelővel várunk rá, időkorlát nélkül; az első megjelenéskor
    // érvényesítjük a függőben lévő pill-választást is.
    function onKachingReady() {
      watchKachingSelection();
      if (pendingKachingIndex !== null) selectKachingBar(pendingKachingIndex);
    }

    if (getKachingBars().length) {
      onKachingReady();
    } else {
      var bodyObserver = new MutationObserver(function () {
        if (getKachingBars().length) {
          bodyObserver.disconnect();
          onKachingReady();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        bodyObserver.disconnect();
      }, 120000);
    }

    /* ---------- Kosárba tétel ---------- */

    function getProductFormComponent() {
      return document.querySelector('product-form-component[data-product-id="' + productId + '"]');
    }

    function getThemeAtcButton() {
      var formComponent = getProductFormComponent();
      return formComponent ? formComponent.querySelector('[ref="addToCartButton"]') : null;
    }

    // Dupla kattintás és dupla kosárba tétel elleni zár
    var isAdding = false;
    var addSafetyTimer = null;
    var verifyTimer = null;

    function lockAdding() {
      isAdding = true;
      cta.setAttribute('aria-disabled', 'true');
      if (addSafetyTimer) clearTimeout(addSafetyTimer);
      addSafetyTimer = setTimeout(unlockAdding, 8000);
    }

    function unlockAdding() {
      isAdding = false;
      cta.removeAttribute('aria-disabled');
      if (addSafetyTimer) {
        clearTimeout(addSafetyTimer);
        addSafetyTimer = null;
      }
    }

    function onCartUpdate() {
      var btn = getThemeAtcButton();
      if (btn && btn.dataset.puppet === 'true') {
        btn.dataset.puppet = 'false';
        unlockAdding();
        // A visszajelzés csak valóban sikeres kosárba tétel után villan fel
        root.classList.add('fx-added');
        setTimeout(function () {
          root.classList.remove('fx-added');
        }, 1600);
      }
    }

    function onCartError() {
      var btn = getThemeAtcButton();
      if (btn) btn.dataset.puppet = 'false';
      unlockAdding();
    }

    document.addEventListener('cart:update', onCartUpdate);
    document.addEventListener('cart:error', onCartError);

    // A téma valódi Kosárba gombjának megnyomása (puppet minta). A Kaching a
    // gombkattintáskor szinkron újraolvassa a kiválasztott csomagot, majd a
    // kosár-kérésben a pontos darabszámot érvényesíti.
    function puppetClick() {
      var btn = getThemeAtcButton();
      if (!btn || btn.disabled) {
        directAdd();
        return;
      }

      btn.dataset.puppet = 'true';
      btn.click();
    }

    // Tartalék ág: a kiválasztott darabszám közvetlen kosárba tétele. A
    // ?kaching_bundles=true jelölést a Kaching elfogója kihagyja, így a darabszámot
    // garantáltan semmi nem írja át. Hálózati hibánál GET végpontra váltunk.
    function directAdd() {
      var variantId = parseInt(root.dataset.variantId, 10);
      var quantity = deals[selectedIndex].quantity;
      if (!variantId) {
        unlockAdding();
        return;
      }

      if (window.console && console.warn) {
        console.warn('[FeroxStickyBar] Kaching szinkron nem igazolható, közvetlen kosárba tétel:', quantity, 'db');
      }

      fetch('/cart/add.js?kaching_bundles=true', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function () {
          // Siker és 4xx esetén is a kosároldal mutatja a tényleges állapotot;
          // itt sosem próbálkozunk újra, hogy dupla hozzáadás ne történhessen.
          window.location.href = '/cart';
        })
        .catch(function () {
          // Hálózati hibánál sem próbálkozunk újra (a kérés célba érhetett,
          // az ismétlés dupla hozzáadást kockáztatna): a kosároldal mutatja
          // a tényleges állapotot, onnan egy kattintás a folytatás.
          window.location.href = '/cart';
        });
    }

    function handleCtaClick() {
      var btn = getThemeAtcButton();
      if (!btn || btn.disabled) return;

      lockAdding();

      var bars = getKachingBars();
      if (!bars.length) {
        directAdd();
        return;
      }

      if (isKachingSelected(selectedIndex)) {
        puppetClick();
        return;
      }

      // Kiválasztás a rádión keresztül: szinkron visszajelzést ad
      if (selectKachingBar(selectedIndex) && isKachingSelected(selectedIndex)) {
        puppetClick();
        return;
      }

      // Rövid türelmi ablak (a Kaching állapotfrissítése mikrotaszkban fut),
      // utána ha továbbra sem igazolt a kiválasztás, jön a garantált tartalék ág.
      var attempts = 0;
      verifyTimer = setInterval(function () {
        attempts++;
        if (isKachingSelected(selectedIndex)) {
          clearInterval(verifyTimer);
          verifyTimer = null;
          puppetClick();
        } else if (attempts >= 6) {
          clearInterval(verifyTimer);
          verifyTimer = null;
          directAdd();
        }
      }, 100);
    }

    cta.addEventListener('click', function () {
      if (isAdding) return;
      if (verifyTimer) {
        clearInterval(verifyTimer);
        verifyTimer = null;
      }
      try {
        handleCtaClick();
      } catch (e) {
        if (window.console && console.warn) console.warn('[FeroxStickyBar] CTA hiba:', e);
        directAdd();
      }
    });

    paintSelection();

    /* ---------- Megjelenítés és elrejtés görgetésre (felső sáv) ---------- */

    var buyBlock =
      document.querySelector('.buy-buttons-block') || getProductFormComponent();
    if (!buyBlock) return;

    var isStuck = false;
    var hiddenByFooter = false;

    function show() {
      if (isStuck) return;
      isStuck = true;
      root.dataset.stuck = 'true';
    }

    function hide() {
      if (!isStuck) return;
      isStuck = false;
      root.dataset.stuck = 'false';
    }

    function buyBlockIsAbove() {
      var rect = buyBlock.getBoundingClientRect();
      return rect.bottom < 0 || rect.top < 0;
    }

    var buyObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      if (!entry.isIntersecting) {
        if (buyBlockIsAbove() && !hiddenByFooter) show();
      } else {
        hiddenByFooter = false;
        hide();
      }
    });
    buyObserver.observe(buyBlock);

    // A láblécnél a sáv elrejtőzik, hogy ne takarja a footer tartalmát
    var footer =
      document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    if (footer) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          if (entry.isIntersecting && isStuck) {
            hiddenByFooter = true;
            hide();
          } else if (!entry.isIntersecting && hiddenByFooter) {
            hiddenByFooter = false;
            if (buyBlockIsAbove()) show();
          }
        },
        { rootMargin: '0px 0px 200px 0px' }
      );
      footerObserver.observe(footer);
    }

    // Ha az oldal már túlgörgetve töltődik be (pl. horgonyról), azonnal jelenjen meg
    if (buyBlockIsAbove()) show();
  }
})();
